<div class="gbar-wrapper">
    <svg #svg></svg>
</div>
